<template>
  <div class="top-terms">
    <div class="top-terms__tabs">
      <ul class="top-terms__tabs__index">
        <li v-for="tab in tabsActive" :key="tab.key" class="top-terms__tabs__index__tab"
          :class="{ 'top-terms__tabs__index__tab--on': tabSelected === tab.key }">
          <a :href="`#${tab.key}`" @click.prevent="tabSelected = tab.key">
            {{ tab.label }}
            <SvgIconFlag v-if="tab.key === 'topTermsTabTracking'" />
          </a>
        </li>
      </ul>

      <!-- Tab terms -->
      <div v-show="tabSelected === 'topTermsTabMostSpoken'" id="topTermsTabMostSpoken" class="top-terms__tabs__content">
        <WidgetAttendancesRefusal unboxed />
      </div>

      <!-- Tab trends -->
      <div v-show="tabSelected === 'topTermsTabTrends'" id="topTermsTabTrends" class="top-terms__tabs__content">
        <WidgetAttendancesRefusalConversion unboxed />
      </div>
    </div>
  </div>
</template>

<script>
import { dateFilter, percentageFilter, capitalizeFilter } from '@/utils/filters'
import BasePaneCard from '@/components/base/BasePaneCard'
import BaseEmptyState from '@/components/base/BaseEmptyState'
import WidgetAttendancesRefusal from '@/components/widget/WidgetAttendancesRefusal'
import WidgetAttendancesRefusalConversion from '@/components/widget/WidgetAttendancesRefusalConversion'
import BaseBubbleWord from '@/components/base/BaseBubbleWord'
import BaseInputSearch from '@/components/base/BaseInputSearch'
import CommonLeadConversations from '@/components/common/CommonLeadConversations'
import PartialTopTermsButtonTracking from '@/components/partials/PartialTopTermsButtonTracking'
import { mapState, mapGetters } from 'vuex'
import { mount } from '@vue/test-utils'

export default {
  name: 'WidgetTopTerms',

  components: {
    BasePaneCard,
    WidgetAttendancesRefusal,
    WidgetAttendancesRefusalConversion,
    BaseEmptyState,
    BaseBubbleWord,
    BaseInputSearch,
    CommonLeadConversations,
    PartialTopTermsButtonTracking
  },

  filters: {
    date: dateFilter,
    percentage: percentageFilter,
    capitalize: capitalizeFilter
  },

  data() {
    return {
      isLoading: false,
      isLoadingTracking: false,
      dataset: null,
      isSmartFilter: true,
      tabs: [
        {
          key: 'topTermsTabMostSpoken',
          label: 'Motivos de recusa',
          isActive: true
        }
      ],
      tabSelected: 'topTermsTabMostSpoken',
      isOpenLeadConversations: true,
      leadConversations: {
        filter: 'word',
        key: '',
        urlParams: ''
      },
      search: {
        terms: '',
        trends: '',
        tracking: ''
      }
    }
  },

  computed: {
    ...mapState('base', [
      'mainApi',
      'pageFilter'
    ]),

    ...mapGetters('auth', [
      'userId',
      'platformId'
    ]),

    tabsActive() {
      return this.tabs.filter(tab => tab.isActive)
    }
  },

  beforeMount() {
    if (this.$auth.user().platform_name === 'sem-parar') {
      this.$set(this.tabs, this.tabs.length, {
        key: 'topTermsTabTrends',
        label: 'Motivos de conversão',
        isActive: true
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.top-terms {
  $gap: map-get($layout-insights, 'gap');
  $border: 2px solid nth($colors-custom, 8);
  $border-radius: map-get($layout-insights, 'border-radius');

  position: relative;
  border: $border;
  border-radius: $border-radius;
  background: #fff;

  &__tabs {
    &__index {
      z-index: 2;
      position: relative;
      margin: 0 0 -4px 0;

      &__tab {
        display: inline;

        a {
          display: inline-block;
          padding: 15px 25px;
          border: $border;

          border: {
            bottom: 0;
            color: transparent;
          }

          border-radius: $border-radius $border-radius 0 0;
          transform: translate(-2px, -2px);

          font: {
            weight: 700;
            size: 16px;
          }

          color: map-get($colors-util, 'muted');

          svg {
            width: 13px;
            margin-left: 2px;
            fill: map-get($colors-util, 'muted');
          }
          &:hover {
            color: nth($colors-custom, 2);

            svg {
              fill: nth($colors-custom, 1);
            }
          }
        }

        &--on {
          a {
            border-color: nth($colors-custom, 8);
            background: #fff;
            color: nth($colors-custom, 1);

            svg {
              fill: nth($colors-custom, 1);
            }
          }
        }
      }
    }

    &__content {
      // z-index: 1;
      position: relative;
      height: 520px;
      overflow: auto;
      padding: map-get($layout-insights, 'gap');
      border-top: $border;
      // transform: translateY(-4px);

      /deep/ {
        .pane-card {
          &__body {
            height: 330px;
          }
        }
      }
    }
  }

  &__smart-filter {
    z-index: 3;
    position: absolute;
    top: 10px;
    right: 30px;
    display: inline-flex;
    height: 32px;
    align-items: center;
    gap: 10px;
    padding: 6px 20px;
    border: 2px solid nth($colors-custom, 1);
    border-radius: 2em;
    transition: all 0.1s;
    background: none;
    color: nth($colors-custom, 1);

    font: {
      weight: 600;
      size: 12px;
    }

    line-height: 100%;

    &::after {
      content: '+';
      display: block;
      transition: all 0.1s;

      font: {
        weight: 500;
        size: 16px;
      }
    }

    &--on {
      background: nth($colors-custom, 1);
      color: #fff;

      &::after {
        transform: rotate(45deg);
      }
    }

    &--disabled {
      cursor: wait;
    }

    &:hover {
      border-color: nth($colors-custom, 2);
      background: nth($colors-custom, 2);
      color: nth($colors-custom, 1);
    }
  }

  &__container {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  &__chart {
    flex-grow: 1;

    /deep/ {
      .pane-card {
        &__body {
          height: auto;
        }
      }

      .bubble-word {
        max-width: 540px;
        margin: 0 auto;
      }
    }
  }

  &__list {
    @extend %scrollbar;

    flex: 0 0 370px;
    display: flex;
    height: 100%;
    flex-direction: column;
    gap: 20px;
    padding-left: $gap;
    margin-left: $gap;
    border-left: 1px solid nth($colors-custom, 4);

    ul {
      overflow: auto;
      padding-right: 15px;
    }

    &__item {
      display: flex;
      min-height: 34px;
      gap: 10px;
      border: 1px solid nth($colors-custom, 4);
      border-radius: 8px;
      line-height: 100%;

      &:not(:first-child) {
        margin-top: 8px;
      }

      &__percentage {
        display: flex;
        width: 57px;
        justify-content: flex-end;
        align-items: center;
        font-size: 14px;

        &--diff {
          width: 80px;
          justify-content: flex-start;
          padding-left: 5px;
          border-radius: 8px 0 0 8px;
          background: nth($colors-custom, 1);
          color: #fff;

          font: {
            weight: 600;
            size: 12px;
          }

          span {
            display: inline-block;
            padding-left: 15px;

            background: {
              position: 0 50%;
              repeat: no-repeat;
              size: 12px auto;
            }
          }
        }

        &--up {
          color: nth($colors-custom, 6);

          span {
            background-image: url('~@/assets/img/main/icons/icon-variation-up.svg');
          }
        }

        &--down {
          color: map-get($colors-util, 'muted');

          span {
            background-image: url('~@/assets/img/main/icons/icon-variation-down.svg');
          }
        }

        &--zero {
          background: nth($colors-custom, 4);
          color: nth($colors-custom, 1);

          span {
            background-image: url('~@/assets/img/main/icons/icon-variation-zero.svg');
          }
        }

        &--null {
          background: nth($colors-custom, 4);
          color: nth($colors-custom, 1);

          span {
            background-image: url('~@/assets/img/main/icons/icon-variation-null.svg');
          }
        }

        &--new {
          background: nth($colors-custom, 2);
          color: nth($colors-custom, 1);
        }
      }

      &__term {
        flex-grow: 1;
        display: flex;
        align-items: center;

        font: {
          weight: 600;
          size: 14px;
        }
      }

      &__tray {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 0 10px;
      }

      &__button {
        display: flex;
        width: 13px;
        height: 13px;
        justify-content: center;
        align-items: center;
        padding: 0;
        border: 0;
        background: none;

        &:hover {
          svg {
            fill: nth($colors-custom, 2);
          }
        }

        &--loading {
          opacity: 0.3;
          pointer-events: none;
        }

        svg {
          transition: all 0.1s;
          fill: nth($colors-custom, 1);
        }

        &--tracking {
          width: 13px;
          height: 13px;
        }

        &--chat {
          width: 15px;
          height: 15px;
        }
      }
    }

    &__search {
      position: relative;

      &--not-found {
        /deep/ {
          input {
            padding-right: 160px;
          }
        }
      }

      &__not-found {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);

        font: {
          style: italic;
          size: 12px;
        }
      }
    }

    &__tracking-add {
      transition: all 0.1s;
      color: nth($colors-custom, 1);
      font-size: 12px;
      line-height: 140%;

      &:hover {
        color: nth($colors-custom, 2) !important;
      }

      strong {
        font-weight: 700;
      }
    }
  }
}
</style>
